import React from "react";

import PropTypes from "prop-types";

export default function Table({ children }) {
  return <table className="w-full">{children}</table>;
}

Table.propTypes = {
  children: PropTypes.node,
};
